
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as indexyqiTpI2KlsMeta } from "/codebuild/output/src899704325/src/pages/index.vue?macro=true";
import { default as aboutQvKk65mIwvMeta } from "/codebuild/output/src899704325/src/pages/about.vue?macro=true";
import { default as datal5zbFIuQFEMeta } from "/codebuild/output/src899704325/src/pages/account-settings/data.vue?macro=true";
import { default as manage_45subscriptionzTTmmtKOqrMeta } from "/codebuild/output/src899704325/src/pages/account-settings/manage-subscription.vue?macro=true";
import { default as positioningkMgr4IuE1QMeta } from "/codebuild/output/src899704325/src/pages/account-settings/positioning.vue?macro=true";
import { default as privacyDdVCqNSCjFMeta } from "/codebuild/output/src899704325/src/pages/account-settings/privacy.vue?macro=true";
import { default as remove_45account1cDYb2dQWKMeta } from "/codebuild/output/src899704325/src/pages/account-settings/remove-account.vue?macro=true";
import { default as statueoo0nmoKM98Meta } from "/codebuild/output/src899704325/src/pages/account-settings/statue.vue?macro=true";
import { default as supportXINnO9suPjMeta } from "/codebuild/output/src899704325/src/pages/account-settings/support.vue?macro=true";
import { default as account_45settingsCQRD4okdfUMeta } from "/codebuild/output/src899704325/src/pages/account-settings.vue?macro=true";
import { default as activate_45accounthZtJGINGLaMeta } from "/codebuild/output/src899704325/src/pages/activate-account.vue?macro=true";
import { default as companyDOcKmoGDFAMeta } from "/codebuild/output/src899704325/src/pages/admin/company.vue?macro=true";
import { default as consents0VaO2OLh9jMeta } from "/codebuild/output/src899704325/src/pages/admin/consents.vue?macro=true";
import { default as leadssW89llOipnMeta } from "/codebuild/output/src899704325/src/pages/admin/leads.vue?macro=true";
import { default as paymentswSYbNHYioVMeta } from "/codebuild/output/src899704325/src/pages/admin/payments.vue?macro=true";
import { default as premiumDJQ1vGaQ8jMeta } from "/codebuild/output/src899704325/src/pages/admin/premium.vue?macro=true";
import { default as profiles1E1DfXo0cmMeta } from "/codebuild/output/src899704325/src/pages/admin/profiles.vue?macro=true";
import { default as usersjHEE3YMrsoMeta } from "/codebuild/output/src899704325/src/pages/admin/users.vue?macro=true";
import { default as change_45passwordGtiBRoJGbNMeta } from "/codebuild/output/src899704325/src/pages/change-password.vue?macro=true";
import { default as _91id_93hSqlLlv1GDMeta } from "/codebuild/output/src899704325/src/pages/chat/[id].vue?macro=true";
import { default as ai_46client7DdgwQCFGGMeta } from "/codebuild/output/src899704325/src/pages/chat/ai.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/codebuild/output/src899704325/src/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as index7n3fyCSGzkMeta } from "/codebuild/output/src899704325/src/pages/chat/index.vue?macro=true";
import { default as _91id_93hbiW9DSirPMeta } from "/codebuild/output/src899704325/src/pages/client/profile/[id].vue?macro=true";
import { default as indexxqZ80biiEVMeta } from "/codebuild/output/src899704325/src/pages/client/profile/index.vue?macro=true";
import { default as _91id_93pPILKgdbAXMeta } from "/codebuild/output/src899704325/src/pages/contacts/[id].vue?macro=true";
import { default as index0aPr7AZiFiMeta } from "/codebuild/output/src899704325/src/pages/contacts/index.vue?macro=true";
import { default as contactsoPSnMQgr7mMeta } from "/codebuild/output/src899704325/src/pages/contacts.vue?macro=true";
import { default as _91userId_93rjLRGJYYvQMeta } from "/codebuild/output/src899704325/src/pages/delete-mailing/[email]/[userId].vue?macro=true";
import { default as indexHX8O1K7CtJMeta } from "/codebuild/output/src899704325/src/pages/login/index.vue?macro=true";
import { default as register_45successhmoOsPqDNVMeta } from "/codebuild/output/src899704325/src/pages/login/register-success.vue?macro=true";
import { default as login7Dlp6JpCEEMeta } from "/codebuild/output/src899704325/src/pages/login.vue?macro=true";
import { default as logoutTu0dvto8SBMeta } from "/codebuild/output/src899704325/src/pages/logout.vue?macro=true";
import { default as consentsqA0IgZMLAXMeta } from "/codebuild/output/src899704325/src/pages/manager/consents.vue?macro=true";
import { default as integrationsP3U9BXp1lKMeta } from "/codebuild/output/src899704325/src/pages/manager/integrations.vue?macro=true";
import { default as leadsnVRWs4tQ1mMeta } from "/codebuild/output/src899704325/src/pages/manager/leads.vue?macro=true";
import { default as paymentsZv4QYOlzH0Meta } from "/codebuild/output/src899704325/src/pages/manager/payments.vue?macro=true";
import { default as profiledfLdHJCATHMeta } from "/codebuild/output/src899704325/src/pages/manager/profile.vue?macro=true";
import { default as teamftZ0MrpZ2iMeta } from "/codebuild/output/src899704325/src/pages/manager/team.vue?macro=true";
import { default as indexHyBn81TmeUMeta } from "/codebuild/output/src899704325/src/pages/marketplace/index.vue?macro=true";
import { default as _91catId_93_46clienttht0PzVgiiMeta } from "/codebuild/output/src899704325/src/pages/marketplace/search/[catId].client.vue?macro=true";
import { default as marketplace3f4jQR1RbGMeta } from "/codebuild/output/src899704325/src/pages/marketplace.vue?macro=true";
import { default as subscribeRVCJqNFdOeMeta } from "/codebuild/output/src899704325/src/pages/newsletter/subscribe.vue?macro=true";
import { default as find_46clientP1x3ffLDKwMeta } from "/codebuild/output/src899704325/src/pages/orders/find.client.vue?macro=true";
import { default as my_46clienttbi3qPexzrMeta } from "/codebuild/output/src899704325/src/pages/orders/my.client.vue?macro=true";
import { default as privacy0GjuNnvMJUMeta } from "/codebuild/output/src899704325/src/pages/privacy.vue?macro=true";
import { default as indexlMozqwtfFhMeta } from "/codebuild/output/src899704325/src/pages/recover/index.vue?macro=true";
import { default as successrnVKbczBP1Meta } from "/codebuild/output/src899704325/src/pages/register/success.vue?macro=true";
import { default as _91id_93d1IZeqY6xmMeta } from "/codebuild/output/src899704325/src/pages/sales/profile/[id].vue?macro=true";
import { default as index5Ot3f4QFYwMeta } from "/codebuild/output/src899704325/src/pages/sales/profile/index.vue?macro=true";
import { default as statuehi8BUOAAcFMeta } from "/codebuild/output/src899704325/src/pages/statue.vue?macro=true";
import { default as successi1BEY1lqjIMeta } from "/codebuild/output/src899704325/src/pages/subscription/success.vue?macro=true";
import { default as component_45stubLNPnhAyVUtMeta } from "/codebuild/output/src899704325/src/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubLNPnhAyVUt } from "/codebuild/output/src899704325/src/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: indexyqiTpI2KlsMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/index.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    meta: aboutQvKk65mIwvMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/about.vue")
  },
  {
    name: "about___pl",
    path: "/pl/about",
    meta: aboutQvKk65mIwvMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/about.vue")
  },
  {
    name: "account-settings___en",
    path: "/en/account-settings",
    meta: account_45settingsCQRD4okdfUMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/account-settings.vue"),
    children: [
  {
    name: "account-settings-data___en",
    path: "data",
    component: () => import("/codebuild/output/src899704325/src/pages/account-settings/data.vue")
  },
  {
    name: "account-settings-manage-subscription___en",
    path: "manage-subscription",
    component: () => import("/codebuild/output/src899704325/src/pages/account-settings/manage-subscription.vue")
  },
  {
    name: "account-settings-positioning___en",
    path: "positioning",
    component: () => import("/codebuild/output/src899704325/src/pages/account-settings/positioning.vue")
  },
  {
    name: "account-settings-privacy___en",
    path: "privacy",
    component: () => import("/codebuild/output/src899704325/src/pages/account-settings/privacy.vue")
  },
  {
    name: "account-settings-remove-account___en",
    path: "remove-account",
    component: () => import("/codebuild/output/src899704325/src/pages/account-settings/remove-account.vue")
  },
  {
    name: "account-settings-statue___en",
    path: "statue",
    component: () => import("/codebuild/output/src899704325/src/pages/account-settings/statue.vue")
  },
  {
    name: "account-settings-support___en",
    path: "support",
    component: () => import("/codebuild/output/src899704325/src/pages/account-settings/support.vue")
  }
]
  },
  {
    name: "account-settings___pl",
    path: "/pl/account-settings",
    meta: account_45settingsCQRD4okdfUMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/account-settings.vue"),
    children: [
  {
    name: "account-settings-data___pl",
    path: "data",
    component: () => import("/codebuild/output/src899704325/src/pages/account-settings/data.vue")
  },
  {
    name: "account-settings-manage-subscription___pl",
    path: "manage-subscription",
    component: () => import("/codebuild/output/src899704325/src/pages/account-settings/manage-subscription.vue")
  },
  {
    name: "account-settings-positioning___pl",
    path: "positioning",
    component: () => import("/codebuild/output/src899704325/src/pages/account-settings/positioning.vue")
  },
  {
    name: "account-settings-privacy___pl",
    path: "privacy",
    component: () => import("/codebuild/output/src899704325/src/pages/account-settings/privacy.vue")
  },
  {
    name: "account-settings-remove-account___pl",
    path: "remove-account",
    component: () => import("/codebuild/output/src899704325/src/pages/account-settings/remove-account.vue")
  },
  {
    name: "account-settings-statue___pl",
    path: "statue",
    component: () => import("/codebuild/output/src899704325/src/pages/account-settings/statue.vue")
  },
  {
    name: "account-settings-support___pl",
    path: "support",
    component: () => import("/codebuild/output/src899704325/src/pages/account-settings/support.vue")
  }
]
  },
  {
    name: "activate-account___en",
    path: "/en/activate-account",
    meta: activate_45accounthZtJGINGLaMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/activate-account.vue")
  },
  {
    name: "activate-account___pl",
    path: "/pl/activate-account",
    meta: activate_45accounthZtJGINGLaMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/activate-account.vue")
  },
  {
    name: "admin-company___en",
    path: "/en/admin/company",
    meta: companyDOcKmoGDFAMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/admin/company.vue")
  },
  {
    name: "admin-company___pl",
    path: "/pl/admin/company",
    meta: companyDOcKmoGDFAMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/admin/company.vue")
  },
  {
    name: "admin-consents___en",
    path: "/en/admin/consents",
    meta: consents0VaO2OLh9jMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/admin/consents.vue")
  },
  {
    name: "admin-consents___pl",
    path: "/pl/admin/consents",
    meta: consents0VaO2OLh9jMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/admin/consents.vue")
  },
  {
    name: "admin-leads___en",
    path: "/en/admin/leads",
    meta: leadssW89llOipnMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/admin/leads.vue")
  },
  {
    name: "admin-leads___pl",
    path: "/pl/admin/leads",
    meta: leadssW89llOipnMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/admin/leads.vue")
  },
  {
    name: "admin-payments___en",
    path: "/en/admin/payments",
    meta: paymentswSYbNHYioVMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/admin/payments.vue")
  },
  {
    name: "admin-payments___pl",
    path: "/pl/admin/payments",
    meta: paymentswSYbNHYioVMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/admin/payments.vue")
  },
  {
    name: "admin-premium___en",
    path: "/en/admin/premium",
    meta: premiumDJQ1vGaQ8jMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/admin/premium.vue")
  },
  {
    name: "admin-premium___pl",
    path: "/pl/admin/premium",
    meta: premiumDJQ1vGaQ8jMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/admin/premium.vue")
  },
  {
    name: "admin-profiles___en",
    path: "/en/admin/profiles",
    meta: profiles1E1DfXo0cmMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/admin/profiles.vue")
  },
  {
    name: "admin-profiles___pl",
    path: "/pl/admin/profiles",
    meta: profiles1E1DfXo0cmMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/admin/profiles.vue")
  },
  {
    name: "admin-users___en",
    path: "/en/admin/users",
    meta: usersjHEE3YMrsoMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/admin/users.vue")
  },
  {
    name: "admin-users___pl",
    path: "/pl/admin/users",
    meta: usersjHEE3YMrsoMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/admin/users.vue")
  },
  {
    name: "change-password___en",
    path: "/en/change-password",
    meta: change_45passwordGtiBRoJGbNMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/change-password.vue")
  },
  {
    name: "change-password___pl",
    path: "/pl/change-password",
    meta: change_45passwordGtiBRoJGbNMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/change-password.vue")
  },
  {
    name: "chat-id___en",
    path: "/en/chat/:id()",
    meta: _91id_93hSqlLlv1GDMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/chat/[id].vue")
  },
  {
    name: "chat-id___pl",
    path: "/pl/chat/:id()",
    meta: _91id_93hSqlLlv1GDMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/chat/[id].vue")
  },
  {
    name: "chat-ai___en",
    path: "/en/chat/ai",
    meta: ai_46client7DdgwQCFGGMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src899704325/src/pages/chat/ai.client.vue"))
  },
  {
    name: "chat-ai___pl",
    path: "/pl/chat/ai",
    meta: ai_46client7DdgwQCFGGMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src899704325/src/pages/chat/ai.client.vue"))
  },
  {
    name: "chat___en",
    path: "/en/chat",
    meta: index7n3fyCSGzkMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/chat/index.vue")
  },
  {
    name: "chat___pl",
    path: "/pl/chat",
    meta: index7n3fyCSGzkMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/chat/index.vue")
  },
  {
    name: "client-profile-id___en",
    path: "/en/client/profile/:id()",
    meta: _91id_93hbiW9DSirPMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/client/profile/[id].vue")
  },
  {
    name: "client-profile-id___pl",
    path: "/pl/client/profile/:id()",
    meta: _91id_93hbiW9DSirPMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/client/profile/[id].vue")
  },
  {
    name: "client-profile___en",
    path: "/en/client/profile",
    meta: indexxqZ80biiEVMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/client/profile/index.vue")
  },
  {
    name: "client-profile___pl",
    path: "/pl/client/profile",
    meta: indexxqZ80biiEVMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/client/profile/index.vue")
  },
  {
    name: contactsoPSnMQgr7mMeta?.name,
    path: "/en/contacts",
    meta: contactsoPSnMQgr7mMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/contacts.vue"),
    children: [
  {
    name: "contacts-id___en",
    path: ":id()",
    meta: _91id_93pPILKgdbAXMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/contacts/[id].vue")
  },
  {
    name: "contacts___en",
    path: "",
    meta: index0aPr7AZiFiMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/contacts/index.vue")
  }
]
  },
  {
    name: contactsoPSnMQgr7mMeta?.name,
    path: "/pl/contacts",
    meta: contactsoPSnMQgr7mMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/contacts.vue"),
    children: [
  {
    name: "contacts-id___pl",
    path: ":id()",
    meta: _91id_93pPILKgdbAXMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/contacts/[id].vue")
  },
  {
    name: "contacts___pl",
    path: "",
    meta: index0aPr7AZiFiMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/contacts/index.vue")
  }
]
  },
  {
    name: "delete-mailing-email-userId___en",
    path: "/en/delete-mailing/:email()/:userId()",
    meta: _91userId_93rjLRGJYYvQMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/delete-mailing/[email]/[userId].vue")
  },
  {
    name: "delete-mailing-email-userId___pl",
    path: "/pl/delete-mailing/:email()/:userId()",
    meta: _91userId_93rjLRGJYYvQMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/delete-mailing/[email]/[userId].vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexyqiTpI2KlsMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/index.vue")
  },
  {
    name: "index___pl",
    path: "/pl",
    meta: indexyqiTpI2KlsMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/index.vue")
  },
  {
    name: login7Dlp6JpCEEMeta?.name,
    path: "/en/login",
    component: () => import("/codebuild/output/src899704325/src/pages/login.vue"),
    children: [
  {
    name: "login___en",
    path: "",
    meta: indexHX8O1K7CtJMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/login/index.vue")
  },
  {
    name: "login-register-success___en",
    path: "register-success",
    meta: register_45successhmoOsPqDNVMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/login/register-success.vue")
  }
]
  },
  {
    name: login7Dlp6JpCEEMeta?.name,
    path: "/pl/login",
    component: () => import("/codebuild/output/src899704325/src/pages/login.vue"),
    children: [
  {
    name: "login___pl",
    path: "",
    meta: indexHX8O1K7CtJMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/login/index.vue")
  },
  {
    name: "login-register-success___pl",
    path: "register-success",
    meta: register_45successhmoOsPqDNVMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/login/register-success.vue")
  }
]
  },
  {
    name: "logout___en",
    path: "/en/logout",
    meta: logoutTu0dvto8SBMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/logout.vue")
  },
  {
    name: "logout___pl",
    path: "/pl/logout",
    meta: logoutTu0dvto8SBMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/logout.vue")
  },
  {
    name: "manager-consents___en",
    path: "/en/manager/consents",
    meta: consentsqA0IgZMLAXMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/manager/consents.vue")
  },
  {
    name: "manager-consents___pl",
    path: "/pl/manager/consents",
    meta: consentsqA0IgZMLAXMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/manager/consents.vue")
  },
  {
    name: "manager-integrations___en",
    path: "/en/manager/integrations",
    meta: integrationsP3U9BXp1lKMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/manager/integrations.vue")
  },
  {
    name: "manager-integrations___pl",
    path: "/pl/manager/integrations",
    meta: integrationsP3U9BXp1lKMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/manager/integrations.vue")
  },
  {
    name: "manager-leads___en",
    path: "/en/manager/leads",
    meta: leadsnVRWs4tQ1mMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/manager/leads.vue")
  },
  {
    name: "manager-leads___pl",
    path: "/pl/manager/leads",
    meta: leadsnVRWs4tQ1mMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/manager/leads.vue")
  },
  {
    name: "manager-payments___en",
    path: "/en/manager/payments",
    meta: paymentsZv4QYOlzH0Meta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/manager/payments.vue")
  },
  {
    name: "manager-payments___pl",
    path: "/pl/manager/payments",
    meta: paymentsZv4QYOlzH0Meta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/manager/payments.vue")
  },
  {
    name: "manager-profile___en",
    path: "/en/manager/profile",
    meta: profiledfLdHJCATHMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/manager/profile.vue")
  },
  {
    name: "manager-profile___pl",
    path: "/pl/manager/profile",
    meta: profiledfLdHJCATHMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/manager/profile.vue")
  },
  {
    name: "manager-team___en",
    path: "/en/manager/team",
    meta: teamftZ0MrpZ2iMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/manager/team.vue")
  },
  {
    name: "manager-team___pl",
    path: "/pl/manager/team",
    meta: teamftZ0MrpZ2iMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/manager/team.vue")
  },
  {
    name: marketplace3f4jQR1RbGMeta?.name,
    path: "/en/marketplace",
    meta: marketplace3f4jQR1RbGMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace___en",
    path: "",
    component: () => import("/codebuild/output/src899704325/src/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-search-catId___en",
    path: "search/:catId()",
    meta: _91catId_93_46clienttht0PzVgiiMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src899704325/src/pages/marketplace/search/[catId].client.vue"))
  }
]
  },
  {
    name: marketplace3f4jQR1RbGMeta?.name,
    path: "/pl/marketplace",
    meta: marketplace3f4jQR1RbGMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace___pl",
    path: "",
    component: () => import("/codebuild/output/src899704325/src/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-search-catId___pl",
    path: "search/:catId()",
    meta: _91catId_93_46clienttht0PzVgiiMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src899704325/src/pages/marketplace/search/[catId].client.vue"))
  }
]
  },
  {
    name: "newsletter-subscribe___en",
    path: "/en/newsletter/subscribe",
    meta: subscribeRVCJqNFdOeMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/newsletter/subscribe.vue")
  },
  {
    name: "newsletter-subscribe___pl",
    path: "/pl/newsletter/subscribe",
    meta: subscribeRVCJqNFdOeMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/newsletter/subscribe.vue")
  },
  {
    name: "orders-find___en",
    path: "/en/orders/find",
    meta: find_46clientP1x3ffLDKwMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src899704325/src/pages/orders/find.client.vue"))
  },
  {
    name: "orders-find___pl",
    path: "/pl/orders/find",
    meta: find_46clientP1x3ffLDKwMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src899704325/src/pages/orders/find.client.vue"))
  },
  {
    name: "orders-my___en",
    path: "/en/orders/my",
    meta: my_46clienttbi3qPexzrMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src899704325/src/pages/orders/my.client.vue"))
  },
  {
    name: "orders-my___pl",
    path: "/pl/orders/my",
    meta: my_46clienttbi3qPexzrMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src899704325/src/pages/orders/my.client.vue"))
  },
  {
    name: "privacy___en",
    path: "/en/privacy",
    meta: privacy0GjuNnvMJUMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/privacy.vue")
  },
  {
    name: "privacy___pl",
    path: "/pl/privacy",
    meta: privacy0GjuNnvMJUMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/privacy.vue")
  },
  {
    name: "recover___en",
    path: "/en/recover",
    meta: indexlMozqwtfFhMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/recover/index.vue")
  },
  {
    name: "recover___pl",
    path: "/pl/recover",
    meta: indexlMozqwtfFhMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/recover/index.vue")
  },
  {
    name: "register-success___en",
    path: "/en/register/success",
    component: () => import("/codebuild/output/src899704325/src/pages/register/success.vue")
  },
  {
    name: "register-success___pl",
    path: "/pl/register/success",
    component: () => import("/codebuild/output/src899704325/src/pages/register/success.vue")
  },
  {
    name: "sales-profile-id___en",
    path: "/en/sales/profile/:id()",
    meta: _91id_93d1IZeqY6xmMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/sales/profile/[id].vue")
  },
  {
    name: "sales-profile-id___pl",
    path: "/pl/sales/profile/:id()",
    meta: _91id_93d1IZeqY6xmMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/sales/profile/[id].vue")
  },
  {
    name: "sales-profile___en",
    path: "/en/sales/profile",
    meta: index5Ot3f4QFYwMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/sales/profile/index.vue")
  },
  {
    name: "sales-profile___pl",
    path: "/pl/sales/profile",
    meta: index5Ot3f4QFYwMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/sales/profile/index.vue")
  },
  {
    name: "statue___en",
    path: "/en/statue",
    meta: statuehi8BUOAAcFMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/statue.vue")
  },
  {
    name: "statue___pl",
    path: "/pl/statue",
    meta: statuehi8BUOAAcFMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/statue.vue")
  },
  {
    name: "subscription-success___en",
    path: "/en/subscription/success",
    meta: successi1BEY1lqjIMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/subscription/success.vue")
  },
  {
    name: "subscription-success___pl",
    path: "/pl/subscription/success",
    meta: successi1BEY1lqjIMeta || {},
    component: () => import("/codebuild/output/src899704325/src/pages/subscription/success.vue")
  },
  {
    name: component_45stubLNPnhAyVUtMeta?.name,
    path: "/old-page",
    component: component_45stubLNPnhAyVUt
  }
]